import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'pxc-scan-loader',
  imports: [],
  templateUrl: './scan-loader.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class:
      'pointer-events-none h-full w-full absolute inset-0 overflow-hidden bg-background-primary/40 flex items-center justify-center',
  },
})
export class ScanLoaderComponent {}
